<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-header pb-0">
        <div class="row">
          <div class="form-group row col-sm-3 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right pb-0"
              >ลูกค้าเริ่ม</label
            >
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption"
                v-model="begin_code"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.code }}/{{ b.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right pb-0"
              >ลูกค้าสุดท้าย</label
            >
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption"
                v-model="end_code"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.code }}/{{ b.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right pb-0"
              >เลือกสาขา</label
            >
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="branch"
                @change="onSelectBranch(branch)"
              >
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                  >{{ b.branch_name }}</option
                >
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right pb-0"
              >เฉพาะค้างชำระ</label
            >
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                style="width: 100%"
                v-model="show_no_pay"
              >
                <a-select-option :value="0"> ไม่ใช่ </a-select-option>
                <a-select-option :value="1"> ใช่ </a-select-option>
              </a-select>
            </div>
          </div>

          <div class="form-group row col-sm-3 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right"
              >จากวันที่</label
            >
            <div class="col-sm-8">
              <a-date-picker
                v-model="startDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right"
              >ถึงวันที่</label
            >
            <div class="col-sm-8">
              <a-date-picker
                v-model="endDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right pb-0"
              >รูปแบบรายงาน</label
            >
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                style="width: 100%"
                v-model="show_item_detail"
              >
                <a-select-option :value="0">
                  แบบแสดงรายละเอียด
                </a-select-option>
                <a-select-option :value="1"> แบบสรุป </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right pb-0"
              >เฉพาะข้ามวัน</label
            >
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                style="width: 100%"
                v-model="show_cross_day"
              >
                <a-select-option :value="0"> ไม่ใช่ </a-select-option>
                <a-select-option :value="1"> ใช่ </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="getReport"
            >
              <i class="fas fa-redo"></i> ประมวลผล
            </button>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/pdf/report_sale_hold_invoice.php"
              method="POST"
              target="_blank"
            >
              <input type="hidden" name="date_start" v-model="startDate" />
              <input type="hidden" name="date_end" v-model="endDate" />
              <input type="hidden" name="host" v-model="form_host" />
              <input type="hidden" name="data" v-model="form_data" />
              <button type="submit" class="btn btn-primary btn-block">
                <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/excel/report_sale_hold_invoice.php"
              method="POST"
              target="_blank"
            >
              <input type="hidden" name="date_start" v-model="startDate" />
              <input type="hidden" name="date_end" v-model="endDate" />
              <input type="hidden" name="data" v-model="form_data" />
              <button type="submit" class="btn btn-info btn-block">
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button>
            </form>
          </div>
        </div>

        <div class="table-responsive-sm mt-3">
          วันที่: <span>{{ dateFormatDMY(startDate) }}</span>
          <span v-if="dateFormatDMY(startDate) !== dateFormatDMY(endDate)">
            ถึง วันที่: {{ dateFormatDMY(endDate) }}
          </span>
          <table
            class="table"
            v-for="(d, i) in report_data"
            :key="'branchData' + i"
          >
            <thead>
              <tr class="head-branch text-left">
                <th colspan="2">
                  สาขา: {{ d ? d.branch_name : "-" }}/จุดขาย:
                  {{ host.host_name }}
                </th>
                <th colspan="6">
                  รวมพักบิล(ช่วงเวลา):
                  {{ numberFormatDecimal(sum_total_amount) }} / รวมบิลขาย:
                  {{ numberFormatDecimal(sum_invoice_amount) }} / คงเหลือ:
                  {{ numberFormatDecimal(sum_remain_amount) }}
                </th>
              </tr>
            </thead>
            <!-- <tbody
              v-for="(r, i) in d.hold_bill"
              :key="'datar' + i"
            > -->
            <tbody v-for="(r, i) in filtersSub(d.hold_bill)" :key="'datar' + i">
              <tr class="text-left thead-dark head_table">
                <td colspan="2">
                  &nbsp;&nbsp; เลขที่ใบพักบิล: {{ r.doc_no }}
                  <span class="text-no-val" v-if="!r.inv_no"> ค้างชำระ </span>
                </td>
                <td colspan="2">
                  เวลา: {{ dateFormatAndTime(r.create_time) }}
                </td>
                <!-- <td colspan="2">พนักงาน: {{ r.create_by }}</td> -->
                <td colspan="2">ลูกค้า: {{ r.ar_name || "-" }}</td>
                <td class="text-right">
                  มูลค่า: {{ numberFormatDecimal(r.total_amount) }}
                </td>
                <td class="text-right">
                  มูลค่า: {{ numberFormatDecimal(r.total_amount) }}
                </td>
                <!-- <td
                  class="text-right"
                >เฉพาะราคาขาย: all</td> -->
              </tr>
              <tr class="thead-dark head_datail" v-if="show_item_detail === 0">
                <th width="10%">บาร์โค้ด</th>
                <th width="25%">รายละเอียด</th>
                <th width="10%">หน่วยนับ</th>
                <th width="10%">ราคาขาย</th>
                <th width="10%">จำนวน</th>
                <th width="10%">ส่วนลด</th>
                <th width="15%">ราคารวม</th>
                <th width="10%">แก้ไข</th>
              </tr>
              <tr
                v-for="(s, i) in r.subs"
                :key="'csub' + i"
                v-if="show_item_detail === 0"
              >
                <td class="text-center">{{ s.item_code }}</td>
                <td class="text-left">{{ s.item_name }}</td>
                <td class="text-center">{{ s.item_unit }}</td>
                <td class="text-right">
                  {{ numberFormatDecimal(s.item_price) }}
                </td>
                <td class="text-right">
                  {{ numberFormatDecimal(s.item_qty) }}
                </td>
                <td class="text-right">
                  {{ numberFormatDecimal(s.item_dis_count_amount) }}
                </td>
                <td class="text-right">
                  {{ numberFormatDecimal(s.item_amount) }}
                </td>
                <td class="text-right">
                  {{ numberFormatDecimal(s.item_amount) }}
                </td>
              </tr>
              <!-- <tr>
                <th
                  colspan="3"
                  class="text-left"
                >ลูกค้า: {{ r.ar_name || '-'}}</th>
              </tr> -->
              <tr class="thead-footer">
                <th colspan="2" class="text-left">
                  เลขบิลขาย: {{ r.inv_no || "-" }}
                </th>
                <th class="text-left" style="color: blue;">
                  เงินสด: {{ numberFormatDecimal(r.cash_amount) || "-" }}
                </th>
                <th class="text-left" v-if="r.bank_amount <= 0">
                  เงินโอน: {{ numberFormatDecimal(r.bank_amount) || "-" }}
                </th>
                <th
                  class="text-left"
                  style="color: black !important;background-color: greenyellow !important;"
                  v-else
                >
                  เงินโอน: {{ numberFormatDecimal(r.bank_amount) || "-" }}
                </th>
                <th class="text-center">
                  {{ r.inv_time != "1990-01-01 00:00:00" ? r.inv_time : "-" }}
                </th>
                <th class="text-right" >
                  {{ numberFormatDecimal(r.inv_total_amount) || "-" }}
                </th>
                <th class="text-right" >
                  {{ numberFormatDecimal(r.inv_total_amount) || "-" }}
                </th>
                <th class="text-center" >
                  <button
                      type="button"
                      class="btn btn-warning btn-sm"
                      style="padding: 0 0.25rem;
                      margin: 0.25rem;"
                      @click="
                      modal_active = true;
                      modal_title = `แก้ไขข้อมูลใบพักบิล : ${r.doc_no} `;
                      editHoldBild(r,d.branch_name);
                    "
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                </th>
              </tr>
            </tbody>
            <tbody v-if="report_data.length === 0">
              <tr>
                <th scope="row" colspan="6">ไม่มีข้อมูล</th>
              </tr>
            </tbody>
          </table>
        </div>
        <a-modal
          :title="modal_title"
          centered
          v-model="modal_active"
          @ok="save_modal()"
          @cancel="close_modal"
        >
          <div class="form-group row mb-1">
            <label for="vendor_name" class="col-sm-3 text-right col-form-label"
              >เลขที่บิลขาย</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="vendor_name"
                disabled="true"
                placeholder="เลขที่บิลขาย...."
                v-model="data_edit.inv_no"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="vendor_name" class="col-sm-3 text-right col-form-label"
              >รายละเอียด</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="vendor_name"
                disabled="true"
                placeholder="รายละเอียด...."
                v-model="data_edit.ar_name"
              />
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="salePrice" class="col-sm-3 text-right col-form-label"
              >หน่วยนับ</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="salePrice"
                maxlength="6"
                placeholder="ราคาขาย...."
                v-model.number="data_edit.cashUnit"
                disabled="true"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="salePrice" class="col-sm-3 text-right col-form-label"
              >ราคาขาย</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="salePrice"
                maxlength="6"
                placeholder="ราคาขาย...."
                :value="numberFormatDecimal(data_edit.total_amount)"
                disabled="true"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="vendor_name" class="col-sm-3 text-right col-form-label"
              >ส่วนลด</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="vendor_name"
                disabled="true"
                placeholder="ส่วนลด...."
                value="0.00"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="vendor_name" class="col-sm-3 text-right col-form-label"
              >ราคารวม</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="vendor_name"
                disabled="true"
                :value="numberFormatDecimal(data_edit.total_amount)"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="vendor_name" class="col-sm-3 text-right col-form-label"
            >สถานะจ่าย</label>
            <div class="col-sm-8">
              <select
                class="form-control"
                id="shift"
                :disabled="data_edit.isStatus == 1 ? false :true"
                v-model="data_edit.isStatus"
              >
                <option
                  v-for="(dp, j) in item_color"
                  :key="j"
                  v-bind:value="dp.code"
                >{{ dp.name }}</option>
              </select>
            </div>
          </div>
        </a-modal>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import apiMain from "../services/service";
import api from "../services/service_report";
import apipos from "../services/service_pos";
import apiCus from "@/services/service_customer";
import apiCenter from "../services/service_undefined";

export default {
  data() {
    return {
      report_data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      data_edit: {},
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      form_data: "",
      form_host: JSON.stringify(this.host),
      branch: 0,
      host_list: [],
      host: null,
      data_cus_list: [],
      begin_code: "",
      end_code: "",
      dyn_address: "",
      show_item_detail: 0,
      show_cross_day: 0,
      show_no_pay: 0,
      modal_title: "",
      modal_active: false,
      item_color: [
        { 'code': 0, 'name': 'ค้างชำระ' },
        { 'code': 1, 'name': 'จ่ายแล้ว' }
      ],
      sum_total_amount: 0,
      sum_invoice_amount: 0,
      sum_remain_amount: 0
    };
  },
  computed: {
    // filtersFunc () {
    //   return this.report_data.filter(item => {
    //     if (this.show_no_pay === 1 && this.show_cross_day === 0) {
    //       console.log('case1', item.hold_bill.length)
    //       for (let index = 0; index < item.hold_bill.length; index++) {
    //         return item.hold_bill[index].inv_no.indexOf('') < 1
    //       }
    //     }
    //     else if (this.show_no_pay === 0 && this.show_cross_day === 1) {
    //       console.log('case2')
    //       for (let index = 0; index < item.hold_bill.length; index++) {
    //         return item.hold_bill[index].create_time.substr(0, 10).indexOf(item.hold_bill[index].inv_time.substr(0, 10)) < 1
    //       }
    //       // return  item.hold_bill.indexOf(
    //       //   (f => f.create_time.substr(0, 10) != f.inv_time.substr(0, 10)) > -1
    //       // )
    //     }
    //     else if (this.show_no_pay === 1 && this.show_cross_day === 1) {
    //       console.log('case3')
    //       return item
    //     } else {
    //       console.log('case4')
    //       return item
    //     }
    //   })
    // },
  },
  methods: {
    save_modal() {
      if(this.data_edit.isStatus == 0 && this.data_edit.inv_no != '' && this.data_edit.inv_no != null ) {
        // console.log(this.data_edit.branchName.replaceAll(" ", ''))
        apiCenter.deleteHoldBil(
          {
            branchName: this.branch.branch_name,
            data: this.data_edit
          },
          this.header,
          result => {
              this.report_data.sum_total_amount += this.data_edit.inv_total_amount;
              this.report_data.sum_invoice_amount -= this.data_edit.inv_total_amount;
              this.sum_total_amount += this.data_edit.inv_total_amount;
              this.sum_invoice_amount -=  this.data_edit.inv_total_amount;
              this.sum_remain_amount = this.sum_total_amount - this.sum_invoice_amount;
              this.data_edit.sub = result.data.success;
              this.data_edit.inv_no = null;
              this.data_edit.isStatus = 0;
              this.data_edit.bank_amount = 0;
              this.data_edit.cash_amount = 0;
              this.data_edit.inv_total_amount = 0;
              this.data_edit.inv_time = null;
              this.modal_active = false;
              this.alert_msg("success", "บันทึกข้อมูลสำเร็จ", result.message);
          },
          error => {
            this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
          }
        );
      }else{
        this.modal_active = false;
      }
    },
    close_modal(){

    },
    editHoldBild(e,branchName) {
      e['cashUnit'] = (e.bank_amount > 0) ? 'เงินโอน' : 'เงินสด'
      e['isStatus'] = (e.inv_no  == '' || e.inv_no == null) ? 0 : 1
      e['branchName'] = branchName;
      this.data_edit = e;
    },
    filtersSub(val) {
      return val.filter(item => {
        if (this.show_no_pay === 1 && this.show_cross_day === 0) {

          if (item.inv_no == "") {
            return item;
          }
        } else if (this.show_no_pay === 0 && this.show_cross_day === 1) {
          console.log("case2");
          if (item.create_time.substr(0, 10) != item.inv_time.substr(0, 10)) {
            return item;
          }
        } else if (this.show_no_pay === 1 && this.show_cross_day === 1) {
          console.log("case3");
          if (
            item.inv_no == "" &&
            item.create_time.substr(0, 10) != item.inv_time.substr(0, 10)
          ) {
            return item;
          }
        } else {
          console.log("case4");
          return item;
        }
      });
    },
    onSelectBranch(val) {
      this.dyn_address = val.dyn_address;
      this.getCus();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getReport() {
      this.$store.commit("Loading");
      var branch = 0;
      this.report_data = [];
      this.form_data = "";
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        id: branch,
        begin_date: this.dateDMY(this.startDate),
        end_date: this.dateDMY(this.endDate),
        company_id: 1,
        branch_id: 1,
        begin_ar: this.begin_code,
        end_ar: this.end_code
      };
      api.reportHoldbillInvoice(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.commit("Loading");
          this.$store.state.isLoading = false;
          if (result.response === "success") {
            this.report_data = result.data;
            if(this.report_data.length > 0) {
              this.sum_total_amount = this.report_data[0].sum_total_amount;
              this.sum_invoice_amount = this.report_data[0].sum_invoice_amount;
              this.sum_remain_amount = this.report_data[0].sum_remain_amount;
            }
            this.form_data = JSON.stringify(this.report_data);
          } else {
            this.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", result.message);
          }
        },
        error => {
          this.$store.commit("Loading");
          this.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", error.message);
          this.$store.state.isLoading = false;
        }
      );
    },
    getHost() {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === "success") {
            this.host_list = result.data;
            this.host = this.host_list[0];
            // this.getReport()
          } else {
            this.alert_msg("warning", "ดึงข้อมูลจุดขายไม่ได้", result.message);
          }
        },
        error => {
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    },
    calQTY(obj) {
      var total = 0;
      obj.forEach(v => {
        total += v["qty"];
      });
      return total;
    },
    calAmount(obj) {
      var total = 0;
      obj.forEach(v => {
        total += v["amount"];
      });
      return total;
    },
    calAmountBranch(obj) {
      var total = 0;
      obj.forEach(v => {
        total += v["total_amount"];
      });
      return total;
    },
    calAmountBranchAll(obj) {
      var total = 0;
      // obj.forEach(v => {
      //   v.forEach(val => {
      //     total += val['total_amount']
      //   })
      // })
      return total;
    },
    capEnter() {
      $("a").on("keyup", function(e) {
        if (e.which == 13) {
          console.log(e.target.href);
        }
      });
    },
    getCus() {
      this.$store.state.isLoading = true;
      let body = {
        keyword: "",
        limit: 100000,
        status: 1
      };
      apiMain.callMisApi(
        this.dyn_address + "/" + "customer/v1/list/customer",
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        body,
        result => {
          if (result.response === "success") {
            this.data_cus_list = result.data;
          } else {
            this.alert_msg("warning", "ดึงข้อมูลลูกหนี้", result.message);
          }
          this.$store.state.isLoading = false;
        },
        error => {
          this.alert_msg("warning", "ดึงข้อมูลลูกหนี้", error.message);
          this.$store.state.isLoading = false;
        }
      );
    },
    timeFormat(str) {
      return moment(str).format("HH:mm:ss");
    },
    sum_qty(obj) {
      let sumQty = 0;
      obj.forEach(val => {
        sumQty += val["cn_qty"];
      });
      return sumQty;
    },
    sum_total(obj) {
      let sum = 0;
      obj.forEach(val => {
        sum += val["total_amount"];
      });
      return sum;
    }
  },
  mounted() {
    this.checkUser();
    this.getHost();
    this.getBranch();

    setTimeout(() => {
      console.log(this.$store.state.branch_list)
      this.branch = this.$store.state.branch_list[0];
      this.dyn_address = this.$store.state.branch_list[0].dyn_address;
      this.getCus();
    }, 500);
  }
};
</script>
<style scoped>
.head_table {
  background-color: #ffffad;
}
.head-branch {
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
.table tbody {
  border-bottom-style: solid;
  padding-bottom: 5px;
}
.table .thead-dark th {
  color: #000000;
  text-align: center;
  background-color: #6599ff;
  border-color: #383f45;
}
.table .thead-footer th {
  color: #000000;
  text-align: center;
  background-color: #ffff;
}
.text-no-val {
  background-color: red;
  border-radius: 8px;
  padding: 3px;
  color: #ffffff !important;
}
.havebankamount {
  color: saddlebrown !important;
  background-color: greenyellow !important;
}
</style>



// WEBPACK FOOTER //
// src/views/report_holding_invoice.vue